import TickList from "../../components/login/Login/TickList";
import Logo from "../../components/login/Logo";
import LoginAndTerms from "../../components/login/Login/LoginAndTerms";
import SignInSide from "../../components/login/Login/signIn";
import { Box, colors, Divider, Typography } from "@mui/material";
import image1 from "../../assets/img/onee.png";
import image2 from "../../assets/img/two.png"
import image3 from "../../assets/img/four.png"
import logo from "../../assets/img/fsl_logo.png"


export default function LoginPage() {

  const text = `LLM Fine-Tuning, RLHF & SFT, Annotation, Model Evaluation, AI Development`
  const words = text.split(',')

  const styles: any = {
    container: {
      color: "white",
      maxWidth: "530px",
      margin: "0 auto",
      padding: "20px",
      textAlign: "justify",
      lineHeight: "1.8",
      fontSize: "44px",
      letterSpacing: "2px",
      fontWeight: "800",
      fontFamily: "Poppins",
      position: 'relative'
    },
    accelerate: {
      position: "absolute",
      top: "0",
      left: "55",
      fontSize: "50px",
      fontFamily: "Poppins",
      textAlign: "center",
      fontWeight: "900",
      background: "linear-gradient(90deg, #FF5F6D, #FFC371)",
      WebkitBackgroundClip: "text",
      color: "transparent",
      animation: "zoomIn 2s ease-out",
    },
    word: {
      display: "inline-block",
      opacity: 0,
      fontFamily: "Poppins",

      animation: "fadeIn 1s forwards",
    }
  };


  // Decorative blobs are positioned in vw/vh (not fixed px) so they scale with the
  // logical CSS viewport instead of overlapping the centered card when OS display
  // scaling (e.g. 150%) shrinks the reported viewport width.
  const blobStyle: any = {
    position: "absolute",
    pointerEvents: "none",
    zIndex: 0,
  };

  return (
    <div style={{ height: "100vh", backgroundColor: "#000000", overflow: "hidden", position: "relative" }}>

      <div
        style={{
          position: "relative",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <section>
          <img src={image2} alt="" style={{ ...blobStyle, height: "clamp(50px, 5.2vw, 100px)", left: "-2vw", top: "9vh" }} />
        </section>

        <section>
          <img src={image1} alt="" style={{ ...blobStyle, height: "clamp(70px, 7.3vw, 140px)", left: "4.7vw", bottom: "16vh" }} />
        </section>




        <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", position: "relative", zIndex: 1 }}>
          <div className="grid place-items-center relative">
            <div className="h-[828px] flex flex-col justify-center gap-2" style={{ width: "450px" }}>

              <h1 className="font-poppins text-2xl leading-[3rem] font-bold text-white" style={{ fontSize: "1.5rem", marginBottom: "15px", textAlign: "center" }}>
                <section style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingBottom: "20px" }}>
                  <img
                    src={logo}
                    alt="FSL logo"
                    style={{
                      marginRight: "10px",
                      height: "60px",
                      width: "auto"
                    }}
                  />
                  <span
                    style={{
                      borderLeft: "1px solid white",
                      paddingLeft: "10px",
                      color: "white",
                      fontSize: "1.2rem",
                      whiteSpace: "nowrap",
                    }}
                  >
                    GenAI Task Execution Platform
                  </span>

                </section>

                Login to continue...
              </h1>
              <SignInSide />
            </div>

          </div>
        </div>
        {/* </Box> */}

        <section>
          <img src={image2} alt="" style={{ ...blobStyle, height: "clamp(65px, 6.8vw, 130px)", right: "0.5vw", bottom: "7.4vh" }} />
        </section>

        <section>
          <img src={image1} alt="" style={{ ...blobStyle, height: "clamp(100px, 10.4vw, 200px)", right: "3.6vw", top: "12vh" }} />
        </section>
      </div>

      <footer style={{ display: "flex", alignItems: "center", justifyContent: "center", color: "white" }}>
        <p className="text-sm font-poppins text-tri-text absolute bottom-5" >
          © 2024 Accunai India Services Pvt. Ltd
        </p>
      </footer>

    </div>
  );
}
